import {
	IconSize50,
	IconSize75,
	IconSize100,
	IconSize150,
	IconSize200,
	IconSize300,
	IconSize400,
	IconSize500,
	IconSize625,
	IconSize750,
} from "@mv/design-tokens/variables";
import { type SVGProps } from "react";
export interface Props
	extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
	size?:
		| "50"
		| "75"
		| "100"
		| "150"
		| "200"
		| "300"
		| "400"
		| "500"
		| "625"
		| "750";
}
const sizeMap = {
	50: IconSize50,
	75: IconSize75,
	100: IconSize100,
	150: IconSize150,
	200: IconSize200,
	300: IconSize300,
	400: IconSize400,
	500: IconSize500,
	625: IconSize625,
	750: IconSize750,
};
export default function IconBoxBlack({ size = "100", ...props }: Props) {
	return (
		<svg
			xmlns={"http://www.w3.org/2000/svg"}
			{...props}
			viewBox="0 0 24 24"
			width={sizeMap[size]}
			height={sizeMap[size]}
		>
			<path d="m20.74 8.51 1.5-1.49c.34-.34.34-.89 0-1.24a.9.9 0 0 0-.19-.14l-6.7-3.84a.864.864 0 0 0-1.05.14l-1.69 1.68a.87.87 0 0 1-1.23 0L9.69 1.94a.88.88 0 0 0-1.05-.14l-6.7 3.84c-.42.24-.56.77-.32 1.19.04.07.09.13.14.19l1.5 1.49c.34.34.34.89 0 1.24l-1.5 1.49c-.34.34-.34.89 0 1.24.06.06.12.1.19.14l1.69.97c.27.16.44.44.44.76v3.11c0 .31.17.6.44.76l7.06 4.05c.27.15.6.15.87 0l7.06-4.04c.27-.16.44-.44.44-.76v-3.12c0-.31.17-.6.44-.76l1.69-.97c.42-.24.56-.77.32-1.19a1.3 1.3 0 0 0-.14-.19l-1.51-1.5a.88.88 0 0 1 0-1.24ZM9.55 3.02l.92.92c.34.34.34.89 0 1.24-.06.06-.12.1-.19.14l-.7.4c-.21.12-.28.38-.16.59s.39.28.6.16l1.54-.88c.27-.15.6-.15.87 0l1.54.88c.21.12.48.05.6-.16s.05-.47-.16-.59l-.7-.4a.868.868 0 0 1-.18-1.37l.92-.91c.28-.28.71-.33 1.05-.14l5.14 2.94c.42.24.56.77.32 1.19-.04.07-.09.13-.14.19l-.92.92c-.28.28-.71.33-1.05.14l-1.32-.76a.44.44 0 0 0-.6.16c-.12.21-.05.47.16.59l.58.33c.3.17.41.56.23.86-.06.1-.14.18-.23.23l-5.23 3c-.27.15-.6.15-.87 0l-5.23-3a.624.624 0 0 1-.23-.86c.06-.1.14-.18.23-.23l.58-.33c.21-.12.28-.38.16-.59a.44.44 0 0 0-.6-.16l-1.32.76c-.34.2-.77.14-1.05-.14l-.92-.92a.88.88 0 0 1 0-1.24c.06-.06.12-.1.19-.14L8.52 2.9c.34-.2.77-.14 1.05.14Zm-3.3 12.07 2.4 1.37c.34.2.77.14 1.05-.14l1.05-1.04c.17-.17.17-.44 0-.61a.44.44 0 0 0-.62 0l-.57.56c-.28.28-.71.33-1.05.14l-5.14-2.94a.87.87 0 0 1-.32-1.19c.04-.07.09-.13.14-.19l.92-.92c.28-.28.71-.33 1.05-.14l5.97 3.42c.27.16.44.44.44.76v5.57c0 .48-.39.87-.87.87-.15 0-.3-.04-.43-.12L5.4 17.7a.88.88 0 0 1-.44-.76v-1.11c0-.48.39-.87.87-.87.15 0 .3.04.43.12Zm12.8 2.38-5.3 3.04c-.42.24-.95.1-1.19-.32a.8.8 0 0 1-.12-.43v-5.57c0-.31.17-.6.44-.76l5.97-3.42c.34-.2.77-.14 1.05.14l.92.92c.34.34.34.89 0 1.24-.06.06-.12.1-.19.14l-5.14 2.94c-.34.2-.77.14-1.05-.14l-.63-.63a.44.44 0 0 0-.62 0c-.17.17-.17.44 0 .61l1.11 1.1c.28.28.71.33 1.05.14l2.4-1.37a.877.877 0 0 1 1.31.75v1.61Z" />
			<path
				fill="#cd0400"
				d="m8.02 6.61.03-.02a.44.44 0 0 1 .6.16c.12.21.05.47-.16.59l-.03.02a.44.44 0 0 1-.6-.16.43.43 0 0 1 .16-.59M15.35 6.76a.44.44 0 0 1 .6-.16l.03.02c.21.12.28.38.16.59a.44.44 0 0 1-.6.16l-.03-.02a.43.43 0 0 1-.16-.59"
			/>
		</svg>
	);
}
